import { httpsCallable } from 'firebase/functions';
import { functions } from '../config';

/**
 * クーポン作成レスポンスの型定義
 */
export interface CreateCouponResponse {
  success: boolean;
  data: {
    coupon_id: string;
    code: string;
    coupon_url: string;
    reward_amount: number;
    end_date: string;
  };
}

/**
 * クーポン検証レスポンスの型定義
 */
export interface ValidateCouponCodeResponse {
  valid: boolean;
  data?: {
    coupon_id: string;
    reward_amount: number;
  };
  error?: {
    code: string;
    message: string;
  };
}

/**
 * クーポン付与レスポンスの型定義
 */
export interface RedeemCouponResponse {
  success: boolean;
  data: {
    reward_amount: number;
  };
}

/**
 * クーポンを作成する（運営管理者用）
 */
export const createCoupon = async (code: string, note?: string): Promise<CreateCouponResponse> => {
  const callable = httpsCallable<{ code: string; note?: string }, CreateCouponResponse>(
    functions,
    'createCoupon',
  );
  const result = await callable({ code, note });
  return result.data;
};

/**
 * クーポンコードを検証する
 */
export const validateCouponCode = async (
  couponCode: string,
): Promise<ValidateCouponCodeResponse> => {
  const callable = httpsCallable<{ coupon_code: string }, ValidateCouponCodeResponse>(
    functions,
    'validateCouponCode',
  );
  const result = await callable({ coupon_code: couponCode });
  return result.data;
};

/**
 * クーポン更新レスポンスの型定義
 */
export interface UpdateCouponResponse {
  success: boolean;
  data: {
    coupon_id: string;
    code: string;
    coupon_url: string;
  };
}

/**
 * クーポンを更新する（運営管理者用）
 */
export const updateCoupon = async (
  couponId: string,
  code: string,
  note?: string,
): Promise<UpdateCouponResponse> => {
  const callable = httpsCallable<
    { coupon_id: string; code: string; note?: string },
    UpdateCouponResponse
  >(functions, 'updateCoupon');
  const result = await callable({ coupon_id: couponId, code, note });
  return result.data;
};

/**
 * クーポンを適用してクレジットを付与する
 */
export const redeemCoupon = async (
  couponCode: string,
  companyId: string,
): Promise<RedeemCouponResponse> => {
  const callable = httpsCallable<{ coupon_code: string; company_id: string }, RedeemCouponResponse>(
    functions,
    'redeemCoupon',
  );
  const result = await callable({ coupon_code: couponCode, company_id: companyId });
  return result.data;
};
